import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../assets/images/Group4.png';
const _withScopeId = n => (_pushScopeId("data-v-438fe043"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "home flex-col"
};
const _hoisted_2 = {
  class: "mobile-carousel imgbg-cover"
};
const _hoisted_3 = ["src"];
const _hoisted_4 = {
  class: "common-dark-theme"
};
const _hoisted_5 = {
  class: "common-title",
  style: {
    "color": "white"
  }
};
const _hoisted_6 = {
  class: "common-dark product-icon"
};
const _hoisted_7 = {
  class: "main-content product-class flex-row-center product-box"
};
const _hoisted_8 = {
  class: "common-dark grey"
};
const _hoisted_9 = {
  class: "common-title"
};
const _hoisted_10 = {
  class: "common-dark grey"
};
const _hoisted_11 = {
  class: "main-content flex-row best-sell-container"
};
const _hoisted_12 = {
  class: "best-sell-img flex-col-center"
};
const _hoisted_13 = {
  class: "img"
};
const _hoisted_14 = {
  class: "title"
};
const _hoisted_15 = {
  class: "best-sell-img flex-col-center"
};
const _hoisted_16 = {
  class: "img"
};
const _hoisted_17 = {
  class: "title"
};
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "common-dark"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "main-content end-block"
}), /*#__PURE__*/_createElementVNode("div", {
  class: "right-block"
})], -1));
const _hoisted_19 = {
  class: "common-dark"
};
const _hoisted_20 = {
  class: "main-content flex-row about-us"
};
const _hoisted_21 = {
  class: "flex-col flex-full"
};
const _hoisted_22 = {
  class: "title"
};
const _hoisted_23 = ["innerHTML"];
const _hoisted_24 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "flex-full"
}, null, -1));
const _hoisted_25 = {
  class: "bt-more flex-row-center"
};
const _hoisted_26 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "arrow-icon"
}, null, -1));
const _hoisted_27 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "img-container"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "img-bg"
}), /*#__PURE__*/_createElementVNode("div", {
  class: "img imgbg-contain"
})], -1));
const _hoisted_28 = {
  class: "common-dark"
};
const _hoisted_29 = {
  class: "common-title"
};
const _hoisted_30 = {
  class: "common-dark"
};
const _hoisted_31 = {
  class: "main-content flex-row honor"
};
const _hoisted_32 = {
  class: "cert flex-col"
};
const _hoisted_33 = {
  class: "title"
};
const _hoisted_34 = {
  class: "common-dark"
};
const _hoisted_35 = {
  class: "common-title"
};
const _hoisted_36 = {
  class: "common-dark"
};
const _hoisted_37 = {
  class: "main-content flex-row",
  style: {
    "padding": "30px 0",
    "gap": "0px"
  }
};
const _hoisted_38 = ["src"];
const _hoisted_39 = {
  class: "common-dark"
};
const _hoisted_40 = {
  class: "main-content"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_carousel_item = _resolveComponent("el-carousel-item");
  const _component_el_carousel = _resolveComponent("el-carousel");
  const _component_LogoIcon = _resolveComponent("LogoIcon");
  const _component_router_link = _resolveComponent("router-link");
  const _component_HBoxList = _resolveComponent("HBoxList");
  const _component_IconList = _resolveComponent("IconList");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_carousel, {
    trigger: "click",
    height: "750px",
    class: "pc-carousel imgbg-cover"
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.carouselImgs, (item, i) => {
      return _openBlock(), _createBlock(_component_el_carousel_item, {
        key: i,
        style: {
          "text-align": "center"
        }
      }, {
        default: _withCtx(() => [_createElementVNode("div", {
          class: "img",
          style: _normalizeStyle('background-image: url(' + _ctx.baseUrl + 'images/' + item.url + ');background-position: ' + item.position)
        }, null, 4)]),
        _: 2
      }, 1024);
    }), 128))]),
    _: 1
  }), _createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.carouselImgs, (item, i) => {
    return _openBlock(), _createElementBlock("div", {
      key: i,
      style: {
        "text-align": "center"
      }
    }, [_createElementVNode("img", {
      src: _ctx.baseUrl + 'images/' + item.url,
      class: "carousel-img",
      style: _normalizeStyle([{
        "width": "100%"
      }, {
        opacity: i == _ctx.currentIndex ? 1 : 0
      }])
    }, null, 12, _hoisted_3)]);
  }), 128))]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('Our_Products')), 1)]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productClass, (item, i) => {
    return _openBlock(), _createBlock(_component_LogoIcon, {
      class: "flex-full",
      key: i,
      data: item
    }, null, 8, ["data"]);
  }), 128))])]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('label32')), 1)]), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createVNode(_component_HBoxList, {
    class: "flex-full best-sell-list pc",
    width: 290 * 4,
    gap: 20,
    count: _ctx.bestSells.length,
    singleWidth: 290
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bestSells, (item, i) => {
      return _openBlock(), _createBlock(_component_router_link, {
        key: i,
        to: item.link
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createElementVNode("div", {
          class: "img-bg imgbg-cover",
          style: _normalizeStyle('background-image: url(' + _ctx.baseUrl + item.img + ');')
        }, null, 4)]), _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t(item.title)), 1)])]),
        _: 2
      }, 1032, ["to"]);
    }), 128))]),
    _: 1
  }, 8, ["count"]), _createVNode(_component_HBoxList, {
    class: "flex-full best-sell-list moblie",
    type: 'moblie',
    width: 90 * 4,
    gap: 10,
    count: _ctx.bestSells.length,
    singleWidth: 100
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bestSells, (item, i) => {
      return _openBlock(), _createBlock(_component_router_link, {
        key: i,
        to: item.link
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_createElementVNode("div", {
          class: "img-bg imgbg-cover",
          style: _normalizeStyle('background-image: url(' + _ctx.baseUrl + item.img + ');')
        }, null, 4)]), _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.$t(item.title)), 1)])]),
        _: 2
      }, 1032, ["to"]);
    }), 128))]),
    _: 1
  }, 8, ["count"])])]), _hoisted_18, _createElementVNode("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.$t('abouts_us')), 1), _createElementVNode("div", {
    class: "des",
    innerHTML: _ctx.$t('label57')
  }, null, 8, _hoisted_23), _hoisted_24, _createVNode(_component_router_link, {
    to: "/about",
    class: "bt-more-link"
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_25, [_createElementVNode("div", null, _toDisplayString(_ctx.$t('learn_more')), 1), _hoisted_26])]),
    _: 1
  })]), _hoisted_27])]), _createElementVNode("div", _hoisted_28, [_createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.$t('label46')), 1)]), _createElementVNode("div", _hoisted_30, [_createElementVNode("div", _hoisted_31, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.honors, (item, i) => {
    return _openBlock(), _createBlock(_component_router_link, {
      key: i,
      to: "/honor"
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_32, [_createElementVNode("div", {
        class: "img imgbg-contain",
        style: _normalizeStyle('background-image: url(' + item.img + ');')
      }, null, 4), _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.$t(item.title)), 1)])]),
      _: 2
    }, 1024);
  }), 128))])]), _createElementVNode("div", _hoisted_34, [_createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.$t("label43")), 1)]), _createElementVNode("div", _hoisted_36, [_createElementVNode("div", _hoisted_37, [_createElementVNode("video", {
    class: "video-company flex-full",
    src: _ctx.baseUrl + 'video/sbg.mp4',
    controls: "",
    poster: _imports_0
  }, null, 8, _hoisted_38)])]), _createElementVNode("div", _hoisted_39, [_createElementVNode("div", _hoisted_40, [_createVNode(_component_IconList)])])]);
}